/** Target length for product SEO titles (Google typically shows ~50–60 chars). */
export const SEO_TITLE_MAX = 60;
export const SEO_BRAND_SUFFIX = 'Laurenti Apparel';

/**
 * Shorten text at a word boundary — no AI, just clean truncation for SERP length.
 */
export function truncateAtWord(text, maxLength) {
  const clean = String(text || '')
    .trim()
    .replace(/\s+/g, ' ');

  if (!clean) return '';
  if (clean.length <= maxLength) return clean;

  const sliced = clean.slice(0, maxLength);
  const lastSpace = sliced.lastIndexOf(' ');
  const base =
    lastSpace > Math.floor(maxLength * 0.5) ? sliced.slice(0, lastSpace) : sliced.trim();

  return base.replace(/[.,;:!\-–—/\s]+$/g, '');
}

/**
 * Auto SEO title: "{Product name} | Laurenti Apparel"
 * Long names are trimmed at a word so the full title stays near SEO_TITLE_MAX.
 */
export function buildProductSeoTitle(
  productName,
  brandSuffix = SEO_BRAND_SUFFIX
) {
  const name = String(productName || '')
    .trim()
    .replace(/\s+/g, ' ');
  const brand = String(brandSuffix || SEO_BRAND_SUFFIX).trim() || SEO_BRAND_SUFFIX;

  if (!name) return brand;

  const suffix = ` | ${brand}`;
  const maxNameLength = Math.max(16, SEO_TITLE_MAX - suffix.length);
  return `${truncateAtWord(name, maxNameLength)}${suffix}`;
}

/** Prefer a saved custom seo_title; otherwise build from the product name. */
export function resolveProductSeoTitle(product, brandSuffix = SEO_BRAND_SUFFIX) {
  const custom = String(product?.seo_title || '').trim();
  if (custom) return custom;
  return buildProductSeoTitle(product?.name, brandSuffix);
}

/**
 * True when the saved title looks like a deliberate override
 * (not empty, not equal to the auto title, not equal to the raw name).
 */
export function isCustomSeoTitle(seoTitle, productName, brandSuffix = SEO_BRAND_SUFFIX) {
  const saved = String(seoTitle || '').trim();
  if (!saved) return false;
  const name = String(productName || '').trim();
  if (saved === name) return false;
  if (saved === buildProductSeoTitle(name, brandSuffix)) return false;
  return true;
}
